import { createApp, h } from 'vue'
import PostChallenge from './AppPostChallenge.vue'
import i18n from '@/i18n'
import trackDirective from '@/directives/trackDirective'
interface PostOptions {
  type: 'default' | 'feeds'
  isMobile?: boolean
  config: any
  scene?: 'challenge' | 'home' | 'normalChallenge' // challenge: 本地上传，home: 首页本地上传 ，normalChallenge：非want，非本地上传的挑战
  hasHistory?: boolean
  checkedLength?: number
  noPost?: boolean
  tabType?: 'history' | 'loacl'
  cancel?: () => void
  success?: (data: any) => void
}

export type PostServiceType = (options: PostOptions) => void

let appInstance: any = null
let app: ReturnType<typeof createApp> | null = null
export const destroyApp = () => {
  // 从 DOM 中移除实例
  app?.unmount()
  appInstance = null

  // 移除临时的 div
  const div = document.querySelector('#create_challenge_container')
  if (div) {
    document.body.removeChild(div)
  }
}
const PostService = (options: PostOptions) => {
  options.hasHistory = options.hasHistory === undefined ? true : options.hasHistory
  options.checkedLength = options.checkedLength === undefined ? 9 : options.checkedLength
  options.noPost = options.noPost === undefined ? false : options.noPost

  if (!appInstance) {
    app = createApp({
      render() {
        return h(PostChallenge, {
          ...options,
          onClose: () => {
            options.cancel?.()
            destroyApp()
          },
          onSuccess: (data: any) => {
            options.success?.(data)
            destroyApp()
          }
        })
      }
    })

    const div = document.createElement('div')
    div.id = 'create_challenge_container'
    document.body.appendChild(div)
    appInstance = app.use(i18n).use(trackDirective).mount(div)
  }
  return {
    destroy: destroyApp
  }
}

export default PostService
